import {useState, useEffect} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';

const PaymentSuccess = () => {
    const navigate = useNavigate();

    useEffect(() => {
        try {
            const params = new URLSearchParams(window.location.search); 
            
            const pi_id = params.get("payment_intent");
            const status = params.get("redirect_status");

            const user = JSON.parse(localStorage.getItem("user"));

            if (pi_id && user && status === 'succeeded') {
                axios.post(process.env.REACT_APP_API_URL + 'signup', {
                    paymentIntentId: pi_id,
                    firstName: user.firstName.trim(),
                    lastName: user.lastName.trim(),
                    email: user.email.trim(),
                    role: user.role,
                    username: user.userName.trim(),
                    password: user.password.trim(),
                    podcastName: user.podcastName,
                    hosted: !!user.hosted
                }).then((r) => {
                        if (r?.data?.token) {
                            localStorage.setItem('jwt', r.data.token);
                            localStorage.removeItem("user");
                            navigate(r.data.to);
                            toast.success('Joined successfully.');
                            return;
                        }
                        navigate('/join?payment-failure=true');
                    }).catch(e => navigate('/join?payment-failure=true'));
            } else {
                navigate('/join?payment-failure=true');
            }
        } catch {
            navigate('/join?payment-failure=true');
        }
    }, []);
    return (
        <div className="payment-validation-text">
            Validating Payment
        </div>
    );
}

export default PaymentSuccess;